const d = 'M378-222 130-470l68-68 180 180 383-383 68 68-451 451Z';

export default d;
